// Nouveau fichier à créer

const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);

// Utiliser les variables d'environnement en priorité
const envApiUrl = process.env.REACT_APP_API_URL;
const envBackendUrl = process.env.REACT_APP_BACKEND_URL;

// Construction des URLs de base
const defaultBackendUrl = isLocalHost 
  ? 'http://localhost:3000' 
  : (envBackendUrl || 'https://flexihub.io'); // ✅ CORRECTION : URL explicite en production

const backendURL = envBackendUrl || defaultBackendUrl;
const baseURL = envApiUrl || `${backendURL}/api`;

export const API_CONFIG = {
  // Propriété baseURL pour la compatibilité
  baseURL: baseURL,
  
  // Méthode pour obtenir l'URL de base du backend (sans /api)
  getBaseUrl: (): string => {
    return backendURL;
  },
  
  // Méthode pour construire les URLs d'API
  getApiUrl: (endpoint: string): string => {
    // Nettoyer l'endpoint
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    
    // Si l'endpoint commence déjà par 'api/', utiliser le backend URL
    if (cleanEndpoint.startsWith('api/')) {
      return `${backendURL}/${cleanEndpoint}`;
    }
    
    // Sinon, utiliser baseURL qui contient déjà /api
    return `${baseURL}/${cleanEndpoint}`;
  }
};

// Log pour debug (désactiver en production)
if (isLocalHost) {
  console.log('🔧 API_CONFIG initialisé:', {
    baseURL: API_CONFIG.baseURL,
    backendURL: API_CONFIG.getBaseUrl(),
    isLocalHost,
    hostname: window.location.hostname
  });
}